import { render, staticRenderFns } from "./enviarCorreo.vue?vue&type=template&id=93e87b18&"
import script from "./enviarCorreo.vue?vue&type=script&lang=js&"
export * from "./enviarCorreo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports